import { gql } from '@apollo/client'

import { REVIEW_FEEDBACK_FRAGMENT } from '../fragments'

export const NEXT_BOUNDING_BOXES_FOR_CLASSIFICATION = gql`
  query NextBoundingBoxesForClassification($upc: String) {
    nextBoundingBoxesForClassification(upc: $upc) {
      __typename
      ... on ClassificationBatch {
        upc
        activeUpc
        originalUpc
        anchorWasReplaced
        requiresAnchorReplacement
        rejectedBoxIds
        classificationReviewBatchId
        returnedFeedbackCount
        reviewFeedback {
          ...ReviewFeedbackFields
        }
        boundingBoxes {
          id
          sourceImageUrl
          minX
          maxX
          minY
          maxY
          metaClass
          isHumanAdded
          isHumanDeleted
          isFlagged
          currentUpc
          flagged {
            level
            moreInfo
            reasons {
              type
              reason
              resolved
            }
          }
          leasedById
          leasedAt
        }
      }
      ... on NoItemsAvailableError {
        code
        message
      }
      ... on LeaseLockError {
        code
        message
        retryAfterMs
      }
    }
  }
  ${REVIEW_FEEDBACK_FRAGMENT}
`
